import { Box } from '@bpba/ui-components';
import { LayoutProps } from '../../types/LayoutProps';

export const ContainerContent = (props: LayoutProps) => {
  return (
    <Box py={['32px', '48px']} flexDirection="column">
      {props.children}
    </Box>
  );
};
